<div class="main-layout vh-100 d-flex flex-column">
  <!-- Top Navigation Bar -->
  <mat-toolbar class="app-toolbar shadow-sm border-bottom" color="primary">
    <!-- Constrain header contents to a centered container so logo and user menu are not flush to page edges -->
    <div class="app-container d-flex align-items-center w-100">
      <h1 class="flex-grow-1 mb-0 fs-4 fw-semibold text-start" style="color: #673ab7;">DigivCards.ai</h1>

      <!-- Navigation Buttons -->
      <div class="d-none d-md-flex align-items-center">
        <a *ngFor="let item of menuItems" mat-icon-button [routerLink]="item.route" [matTooltip]="item.label" routerLinkActive="active-link">
          <mat-icon>{{ item.icon }}</mat-icon>
        </a>
      </div>

      <!-- User Menu -->
      <div class="user-menu ms-3" *ngIf="authService.currentUser as user">
        <button mat-button [matMenuTriggerFor]="userMenu" class="user-button d-flex align-items-center gap-2 text-heading">
          <mat-icon class="text-heading">account_circle</mat-icon>
          <span class="user-name d-none d-md-inline text-truncate max-w-150">{{ user.displayName || user.email }}</span>
          <mat-icon class="text-heading">arrow_drop_down</mat-icon>
        </button>
        
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item [routerLink]="['/profile']" class="d-flex align-items-center gap-3">
            <mat-icon>person</mat-icon>
            <span>Profile</span>
          </button>
          <button mat-menu-item [routerLink]="['/app-settings']" class="d-flex align-items-center gap-3">
            <mat-icon>settings</mat-icon>
            <span>Settings</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()" class="d-flex align-items-center gap-3 text-heading">
            <mat-icon class="text-heading">logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </mat-toolbar>

  <!-- Main Content Area -->
  <main class="app-content flex-grow-1 overflow-auto">
    <router-outlet></router-outlet>   
  </main>
  
  <!-- Footer -->
  <footer class="app-footer mt-auto">
       <app-footer-section></app-footer-section>
  </footer>
</div>
